var _ellipse, _ellipse2, _path, _path2, _path3, _circle, _path4, _circle2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse3, _path13, _path14, _rect, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPandaFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 77,
    viewBox: "0 0 91 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.6438,
    cy: 15.5179,
    rx: 13.3842,
    ry: 14.9722,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.6157,
    cy: 15.5178,
    rx: 13.3842,
    ry: 14.9722,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2026 29.5086L8.2056 29.502L8.20856 29.4954C12.4614 20.0373 17.2888 14.7179 24.9473 9.70523C30.784 5.88497 38.1969 4.13806 45.5436 4.2469C52.8958 4.35582 59.9946 6.32067 65.1781 9.70536C71.3997 13.7821 77.0292 20.2494 80.5106 29.3873L80.5117 29.3901C83.9039 38.2535 84.5328 47.2205 83.031 54.3809C81.5176 61.5964 77.9541 66.5912 73.3144 68.3051C61.8343 72.3035 53.0038 74.3262 44.1964 74.3668C35.3938 74.4074 26.4604 72.4684 14.7823 68.3099C12.892 67.6023 11.0319 65.9517 9.41372 63.3977C7.80222 60.8542 6.51746 57.5451 5.7335 53.7875C4.16236 46.2569 4.66366 37.2299 8.2026 29.5086Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5544 28.7699C17.0977 28.7699 6.68871 40.4795 8.20697 48.7195C9.72523 56.9596 30.5422 58.6943 34.8787 49.37C39.2152 40.0458 34.0112 28.7699 25.5544 28.7699Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7472 28.77C71.2039 28.77 81.6129 40.4796 80.0946 48.7196C78.5764 56.9597 57.7594 58.6944 53.4229 49.3702C49.0864 40.0459 54.2904 28.77 62.7472 28.77Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.0727,
    cy: 45.9007,
    r: 9.54111,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3128 45.6838C35.3128 49.8753 31.9149 53.2733 27.7233 53.2733C26.7099 53.2733 25.7429 53.0747 24.8591 52.7142C25.3961 52.4804 25.7716 51.945 25.7716 51.3218C25.7716 50.4835 25.092 49.8039 24.2537 49.8039C23.4154 49.8039 22.7358 50.4835 22.7358 51.3218C22.7358 51.3503 22.7366 51.3785 22.7381 51.4066C21.1422 50.0152 20.1338 47.9673 20.1338 45.6838C20.1338 41.4922 23.5317 38.0942 27.7233 38.0942C28.6674 38.0942 29.5712 38.2666 30.405 38.5816C29.0013 38.8487 27.9401 40.0823 27.9401 41.5638C27.9401 43.2404 29.2992 44.5996 30.9759 44.5996C32.6525 44.5996 34.0117 43.2404 34.0117 41.5638C34.0117 41.5185 34.0107 41.4735 34.0087 41.4287C34.8319 42.6423 35.3128 44.1069 35.3128 45.6838Z",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.334,
    cy: 45.9006,
    r: 9.54111,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.273 45.6836C68.273 49.8752 64.8751 53.2732 60.6835 53.2732C59.6701 53.2732 58.703 53.0745 57.8191 52.7141C58.3563 52.4803 58.7319 51.9448 58.7319 51.3216C58.7319 50.4833 58.0523 49.8037 57.214 49.8037C56.3757 49.8037 55.6961 50.4833 55.6961 51.3216C55.6961 51.3501 55.6969 51.3784 55.6984 51.4065C54.1025 50.0152 53.094 47.9672 53.094 45.6836C53.094 41.4921 56.4919 38.0941 60.6835 38.0941C61.6276 38.0941 62.5314 38.2665 63.3652 38.5815C61.9615 38.8486 60.9003 40.0822 60.9003 41.5637C60.9003 43.2403 62.2595 44.5995 63.9361 44.5995C65.6128 44.5995 66.972 43.2403 66.972 41.5637C66.972 41.5184 66.971 41.4734 66.969 41.4287C67.7921 42.6422 68.273 44.1068 68.273 45.6836Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9399 61.5688C45.297 69.2893 43.3612 68.828 38.8242 61.5688L41.3196 61.342L42.227 60.8883L43.3612 59.754L44.2686 57.7123L45.176 59.754L46.5372 60.8883L47.4446 61.342L49.9399 61.5688Z",
    fill: "url(#paint0_linear_1128_5377)",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7807 57.2586H43.6789C43.6789 59.2632 42.0538 60.8882 40.0493 60.8882H37.7807V57.2586Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7566 57.2587H44.8585C44.8585 59.2632 46.4835 60.8883 48.4881 60.8883H50.7566V57.2587Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9399 61.5688C45.297 69.2893 43.3612 68.828 38.8242 61.5688L41.3196 61.342L42.227 60.8883L43.3612 59.754L44.2686 57.7123L45.176 59.754L46.5372 60.8883L47.4446 61.342L49.9399 61.5688Z",
    fill: "url(#paint1_linear_1128_5377)",
    stroke: "black",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7807 57.2585H43.6789C43.6789 59.2631 42.0538 60.8882 40.0493 60.8882H37.7807V57.2585Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7566 57.2587H44.8585C44.8585 59.2632 46.4835 60.8883 48.4881 60.8883H50.7566V57.2587Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0513 51.3605C37.4627 51.5873 37.2363 52.4947 38.1439 53.629C40.1853 56.1805 42.6807 57.4855 44.2687 57.4855C45.8567 57.4855 48.0703 56.5352 50.3937 53.629C51.3005 52.4947 50.8468 51.5873 49.4863 51.3605C48.1258 51.1337 40.6399 51.1336 39.0513 51.3605Z",
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.5465,
    cy: 53.175,
    rx: 1.81481,
    ry: 0.907404,
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8194 60.5567C42.0032 60.5566 43.7736 59.1382 43.7735 57.3887C43.7735 57.3062 43.8802 57.2667 43.9242 57.3365C44.1814 57.7456 44.3253 58.2025 44.3253 58.6846C44.3254 60.4341 42.4315 61.8525 40.0953 61.8526C37.7591 61.8527 35.8651 60.4345 35.865 58.685C35.865 58.508 36.1042 58.4898 36.1883 58.6456C36.7955 59.77 38.1928 60.5567 39.8194 60.5567Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8313 60.5563C46.6474 60.5564 44.8769 59.1382 44.8769 57.3887C44.8769 57.3062 44.7701 57.2667 44.7262 57.3365C44.4689 57.7456 44.3251 58.2026 44.3252 58.6847C44.3252 60.4342 46.2192 61.8524 48.5554 61.8523C50.8917 61.8522 52.7855 60.4338 52.7854 58.6843C52.7854 58.5073 52.5462 58.4892 52.4621 58.6449C51.855 59.7694 50.4579 60.5563 48.8313 60.5563Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.8961,
    y: 57.3887,
    width: 0.796981,
    height: 1.43991,
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.278 49.2399C40.8099 48.2799 42.5872 47.7307 44.4824 47.7307C46.0491 47.7307 47.5352 48.106 48.8687 48.7784C47.5974 47.2693 45.9958 46.3696 44.2556 46.3696C42.3446 46.3696 40.6009 47.4544 39.278 49.2399Z",
    fill: "#C2CFD1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1681 10.2374C13.1654 10.4345 13.2601 10.6206 13.4207 10.735L15.6687 12.2879C15.8591 12.4197 15.9547 12.6505 15.9134 12.8786C15.8784 13.1075 15.7145 13.2952 15.4933 13.3625L12.8909 14.1869C12.7997 14.2149 12.7168 14.2642 12.6474 14.33L12.5429 14.435C12.512 14.4768 12.4882 14.524 12.4736 14.5742L11.6642 17.1847C11.6223 17.3119 11.5418 17.423 11.433 17.5021C11.1613 17.6881 10.7906 17.6236 10.5976 17.3566L9.03555 15.1148C8.91928 14.9535 8.73204 14.8589 8.53343 14.8608L5.78565 14.9096C5.55573 14.9135 5.34486 14.7845 5.24434 14.578C5.14266 14.3734 5.16262 14.1295 5.2967 13.9445L6.93395 11.7419C7.0646 11.5805 7.10356 11.3632 7.03745 11.1663L6.14318 8.58686C6.12451 8.52816 6.11472 8.46674 6.11575 8.4053L6.12334 8.34345C6.12133 8.3052 6.1255 8.26771 6.13508 8.23098L6.16163 8.17335L6.20007 8.08052L6.36241 7.91749C6.5225 7.78692 6.73726 7.74551 6.93409 7.80808L9.52073 8.67243C9.70906 8.73656 9.91688 8.70366 10.0766 8.58584L12.2723 6.93925C12.4575 6.79974 12.7051 6.77565 12.9136 6.87606C13.1194 6.97996 13.2462 7.19338 13.2394 7.42409L13.1681 10.2374Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73782 12.2059L7.49355 12.5405C7.0247 13.1827 7.45664 14.0888 8.25078 14.1289L8.77754 14.1555C9.07347 14.1704 9.34754 14.3159 9.52582 14.5525L9.96852 15.1402C10.4102 15.7265 11.3321 15.5542 11.5322 14.848C11.5999 14.6091 11.5645 14.3528 11.4346 14.1412L8.45087 9.28191C8.37681 9.16129 8.26249 9.07074 8.12812 9.02627C7.65877 8.87093 7.21351 9.31808 7.37084 9.78677L7.87817 11.298C7.98139 11.6055 7.92907 11.944 7.73782 12.2059Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1128_5377",
    x1: 44.3821,
    y1: 57.7123,
    x2: 44.3821,
    y2: 66.7335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#860000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1128_5377",
    x1: 44.3821,
    y1: 57.7123,
    x2: 44.3821,
    y2: 66.7335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#860000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7171"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandaFree);
export default __webpack_public_path__ + "static/media/panda-free.6b8a6b7d18ea40cd18f78df57b2d6ba6.svg";
export { ForwardRef as ReactComponent };